"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetsNames = void 0;
exports.widgetsNames = [
    'householdOwnership',
    'householdIncome',
    'wouldLikeToParticipateInOtherSurveysChaireMobilite',
    'wouldLikeToParticipateInOtherSurveysChaireMobiliteContactEmail',
    'householdCommentsOnSurvey',
    'optionalIntroText',
    'householdPluginHybridCarNumber',
    'householdElectricCarNumber',
    'endInterestOfTheSurvey',
    'endTimeSpentAnswering',
    'endDurationOfTheSurvey',
    'endDifficultyOfTheSurvey',
    'endBurdenOfTheSurvey',
    'endConsideredAbandoningSurvey',
    'buttonCompleteInterviewWithCompleteSection'
];
